import { render, staticRenderFns } from "./balanceDetails.vue?vue&type=template&id=42a3cc3d"
import script from "./balanceDetails.vue?vue&type=script&lang=js"
export * from "./balanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports